import { IconAlert } from '@consta/icons/IconAlert'
import { IconTrash } from '@consta/icons/IconTrash'
import { Button } from '@consta/uikit/Button'
import { Checkbox } from '@consta/uikit/Checkbox'
import { Text } from '@consta/uikit/Text'
import { withTooltip } from '@consta/uikit/withTooltip'
import { getSimpleTooltipContent } from '@core/core/helpers'
import type { FC } from 'react'

import { IconDomainTWT } from '../../../../icons'
import css from './ApplyVelocityModel.css'
import type { CheckboxItem, OnChangeCheckboxFunc, PropsObjectList as Props } from './types'

const ButtonAlertWithTooltip = withTooltip({
  content: getSimpleTooltipContent('Карта не соответствует границам выбранной скоростной модели'),
  size: 's',
  direction: 'downCenter',
})(Button)

const unknownErrorNote = 'Произошла неизвестная ошибка'

const iconColor = { color: '#32B4FF' }

export const ObjectList: FC<Props> = ({ items, onChangeObjectList }) => {
  const deleteObject = (name: CheckboxItem['name']) => () => {
    onChangeObjectList(prev => prev.filter(obj => obj.name !== name))
  }

  const onChangeCheckbox: OnChangeCheckboxFunc = name => event => {
    onChangeObjectList(prev => {
      return prev.map(elem =>
        elem.name === name ? { ...elem, checked: event.target.checked } : elem,
      )
    })
  }

  return (
    <>
      {items.map(({ name, checked, error, note }) => (
        <div key={name} className={`${css.object} ${css.objectWrapper}`}>
          <Checkbox
            className={css.objectCheck}
            size="m"
            view="primary"
            checked={checked}
            onChange={onChangeCheckbox(name)}
          />

          <div className={css.twtWrapper}>
            <IconDomainTWT size="s" className={css.twtIcon} style={iconColor} />
            <Text className={css.twtText} size="xs" view="primary">
              {name}
            </Text>

            {!!error && (
              <ButtonAlertWithTooltip
                tooltipProps={{ content: getSimpleTooltipContent(note ?? unknownErrorNote) }}
                size="xs"
                view="clear"
                onlyIcon={true}
                iconLeft={() => <IconAlert view="alert" size="xs" />}
              />
            )}
          </div>

          <Button
            className={css.btnHidden}
            size="xs"
            view="clear"
            onlyIcon={true}
            iconRight={() => <IconTrash size="xs" view="ghost" />}
            onClick={deleteObject(name)}
          />
        </div>
      ))}
    </>
  )
}
